/* ActivityViewComponent.js */

"use strict";
const _ = require("lodash");
const ActivityTypeColumn = require("./column_renderers/activity_type/ActivityTypeComponent");
const SnapshotColumn = require("./column_renderers/snapshot/SnapshotComponent");
const DescriptionColumn = require("./column_renderers/description/DescriptionComponent");
const StatusColumn = require("./column_renderers/status/StatusComponent");
const ActionsColumn = require("./column_renderers/actions/ActionsComponent");

const BaseActivityViewComponent = require("../../../../lib/activity/BaseActivityViewComponent");
const Renderer = require("./ActivityViewRenderer");
const uString = require("underscore.string");

const PagingScheduleActivityFeed = require("./PagingScheduleActivityFeed");
_.mixin(uString.exports());

class ActivityViewComponent extends BaseActivityViewComponent {
    constructor(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory) {
        super(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory);

        this.columnConfig = {
            activityType: {
                label: "Type",
                entityColumn: true,
                columnRendererComponent: ActivityTypeColumn,
                sortable: false,
                width: 50,
                priority: 1,
            },
            snapshot: {
                sort: "desc",
                label: "Activity On",
                entityColumn: true,
                columnRendererComponent: SnapshotColumn,
                width: 150,
                priority: 2,
            },
            description: {
                label: "Description",
                entityColumn: true,
                sortable: false,
                columnRendererComponent: DescriptionColumn,
                width: 220,
                priority: 3,
            },
            status: {
                label: "Status",
                entityColumn: true,
                sortable: false,
                columnRendererComponent: StatusColumn,
                width: 100,
                priority: 4,
            },
            actions: {
                label: "",
                entityColumn: true,
                columnRendererComponent: ActionsColumn,
                sortable: false,
                width: 80,
                priority: 5,
            },
        };

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        if (sorting && Object.keys(sorting).length === 1) {
            switch (true) {
                case sorting.hasOwnProperty("snapshot"):
                    patchedSorting.createdOn = sorting.snapshot;
                    delete patchedSorting.snapshot;
                    break;
                case sorting.hasOwnProperty("status"):
                    patchedSorting.createdOn = -1;
                    break;
            }
        } else {
            patchedSorting.createdOn = -1;
        }
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady() {
        return this._gameEditor.whenTriggerTypeIsReady().then(() => {
            const userSorting = this._userGridData.getSorting() || {};
            const patchedSort = this._patchSorting(userSorting);
            this._entity = this._gameEditor.getTriggerType();
            this._activityFeed = new PagingScheduleActivityFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this._userSession,
                entityDef: this._entity,
                columnConfig: this.columnConfig,
                additionalDataFields: [
                    "jobStatus",
                    "workTypeName",
                    "launchedBy",
                    "expectedExecutionTime",
                    "createdBy",
                    "createdOn",
                    "successCount",
                    "failureCount",
                    "patch",
                    "errorMsg",
                ],
                sort: patchedSort,
            });
            this._registerListeners();
            return this.whenFeedReady();
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ActivityViewComponent;

ActivityViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "$teve.utils",
    "$teve.userSession",
    "$teve.solutionsManager",
    "$teve.storageFactory",
];

ActivityViewComponent.$displayDetails = {
    type: "View",
    name: "Activities",
    icon: "configdrift.activity",
    shown: true,
    title: "Activities",
    order: 5,
};
